// src/components/DataGridWrapper.js
import React, { useEffect, useState, useCallback } from 'react';


import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { Popover, Typography } from '@mui/material';

import { hidePopup, setSelectedTab } from '../slices/uiSlice';
import {
  fetchRecords,
  setPageSize,
  setPage,
  setOrderBy,
  setFilterBy,
  goForward,
  goBackward,
  selectRow,
  setViewRecord,
  setEditRecord,
  setViewNotes,
  setViewPhoneCalls,
  setViewCustomerEmails,
  setRowData,
  editRowField,
  discardEdit,
  startEditingRow,
  batchUpdateFields,
  markColumnsInitialized,
  setColumns
} from '../slices/dataSlice';

import { startCompose } from '../slices/emailSlice.js'

import {
  setCompanyName,
  setCompanyNumber,
  setMainContact,
  fetchCompanyDetails,
  fetchCompanyFilings,
  fetchCompanyOfficers,
  setViewChouseDetails
} from '../slices/chouseSlice.js'


import useLongPress from './useLongPress.js'

import { DataGrid,
    GridRowModes,
    GridToolbarContainer,
    GridActionsCellItem,
    GridToolbarDensitySelector,

} from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Snackbar } from '@mui/material';
import {ttpcolumns, ttpVisibilityModel, ttpsizeOptions} from '../ttpcolumns.js'
import useWindowSize from '../hooks/useWindowSize.js'
import { debounce } from 'lodash';
import PopupNotes from './PopupNotes'
import PopupPhoneCalls from './PopupPhoneCalls'
import PopupCustomerEmails from './PopupCustomerEmails'
import Alert from '@mui/material/Alert';
import CompanyHouseDetails from './CompanyHouseDetails'
import { connectWebSocket, onWebSocketMessage } from '../wsClient.js';
import GenerateAgreement from './GenerateAgreement'
import '../css/DataGridWrapper.css';

function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;

    const handleClick = (clickdrow) => {

        //return
        const id = 20

        setRows((oldRows) => [
        ...oldRows,
        { id, name: '', age: '', role: '', isNew: true },
        ]);

        setRowModesModel((oldModel) => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: 'date_created' },
        }));
    };

    return (
        <GridToolbarContainer>
        <GridToolbarDensitySelector />
        {1===2 && <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
            Add A Record
        </Button> }
        </GridToolbarContainer>
    );
}


const DataGridWrapper =() => {
    const [rowModesModel, setRowModesModel] = useState({});
    const [model,setModel] = useState('ttpcolumns')
    //const [table, setTable] = useState('ttp_leads') // Default to Company Data Mode.
    //const [paginationDirection, setPaginationDirection] = useState('next');
    const [gridheight,setGridHeight] = useState(600)
    const [paginationModel, setPaginationModel] = React.useState({
      pageSize:25,
      page: 0,
    });
    const [filterModel, setFilterModel] = useState({items: [],logicOperator:"and", quickFilterLogicOperator:"and",quickFilterValues:[]})
    const [density, setDensity] = useState('standard')
    const [rowHeight,setRowHeight]=useState(24)
    const [visibilityModel, setVisibilityModel] = useState({})
    const [sizeoptions,setSizeOptions] = useState({})
    const [gridwidth,setGridWidth] = useState("75%");
    const [rows, setRows] = useState([]);
    const [statecolumns,setStateColumns] = useState([])
    const [fullcols, setFullCols] = useState([])
    const [selrow,setSelectedRow]=useState({})
    const [searchfield,setSearchField] = useState('ALL')
    const [searchvalue,setSearchValue] = useState('')

    const [sortModel, setSortModel] = useState([
        {
          field: 'date_created',
          sort: 'desc',
        },
      ]);
    const [columnsInitialized, setColumnsInitialized] = useState(false);
    const [popupnote,openPopupNote]=useState(false)
    const {width,height} = useWindowSize()

    // Context Menus for Each Row
    const [contextMenu, setContextMenu] = useState(null);
    const [showalert, setShowAlert] = useState(false)
    const [alertMsg, setAlertMsg] = useState('')
    const [showAgreement, setShowAgreement] = useState(false)
    const dispatch = useDispatch();
    const debouncedDispatch = debounce((action) => dispatch(action), 500);

    const {
        records,
        loading,
        error,
        pageSize,
        page,
        forwardCursor,
        backwardCursor,
        orderBy,
        filterBy,
        totalCount,
        rowCount,
        loaded,
        rowdata,
        viewNotes,
        viewPhoneCalls,
        viewCustomerEmails
    } = useSelector(state => state.data, shallowEqual);

    const token = useSelector(state => state.data.auth.token);
    const columnSetupDone = useSelector(state => state.data.columnSetupDone, shallowEqual);
    const permission_edit = useSelector(state => state.auth.permission_edit, shallowEqual)

    const anchorEl = useSelector(state => state.uislice.popupAnchor, shallowEqual);
    const popupValue = useSelector(state => state.uislice.popupValue, shallowEqual);
    const popupRowId = useSelector(state => state.uislice.popupRowId, shallowEqual); // if using
    const editedRows = useSelector(state => state.data.editedRows, shallowEqual);
    const loadingFields = useSelector(state => state.data.loadingFields, shallowEqual);

    const columns = useSelector(state => state.data.columns, shallowEqual)


  const [snackbar, setSnackbar] = useState(null);
  const onLongPress = () => {
      console.log('longpress is triggered');
  };

  const onClick = () => {
      console.log('click is triggered')
  }

  const defaultOptions = {
      shouldPreventDefault: true,
      delay: 500,
  };

  const handleEditChange = (id, field, value) => {
    dispatch(editRowField({ id, field, value }));
  };

    const handleSave = async (id) => {
      const updates = editedRows[id];
      if (!updates || Object.keys(updates).length === 0) return;

      // Handle single or multiple field updates via batch thunk
      Object.entries(updates).forEach(([field, value]) => {
        debouncedDispatch(batchUpdateFields({ ids: [id], field, value }));
      });

      dispatch(discardEdit(id));
    };

    const handleCancel = (id) => {
      dispatch(discardEdit(id));
    };

    const processRowUpdate = (newRow, oldRow) => {
      console.log('processRowUpdate ', newRow, oldRow)
      const id = newRow.id;
      Object.keys(newRow).forEach(field => {
        if (newRow[field] !== oldRow[field]) {
          dispatch(editRowField({ id, field, value: newRow[field] }));
        }
      });
      return newRow;
    };


    useEffect(() => {
      connectWebSocket();

      onWebSocketMessage((msg) => {
        if (msg === 'refresh') {
            console.log('[CRM] Refresh triggered via WebSocket');
            dispatch(fetchRecords());
            setAlertMsg("A Lead has been Added or Updated")
            setShowAlert(true)
        }
        else if (msg.substring(0,5) === 'email') {
            const email = msg.split(":")[1].split("[")[1].split("]")[0]
            console.log('[CRM] Refresh triggered via WebSocket');
            setAlertMsg(`A New email for ${email} has been received.`)
            setShowAlert(true)
        }

      });
    }, []);

    const onCloseAlert = () => {
        setShowAlert(false)
    }

  // Load data on mount or when any relevant criteria change
  useEffect(() => {
    if(!loaded) {
        dispatch(fetchRecords());
        dispatch(setViewRecord(false))
        dispatch(setEditRecord(false))
        dispatch(setViewNotes(false))
        dispatch(setViewPhoneCalls(false))
        dispatch(setViewCustomerEmails(false))
    }

  }, [records]);

  const getActionButtons = useCallback((params) => {
    const id = params.id;

    const handleSave = () => {

      const updates = editedRows[id];
      if (!updates || Object.keys(updates).length === 0) return;

      // Handle single or multiple field updates via batch thunk
      Object.entries(updates).forEach(([field, value]) => {
        debouncedDispatch(batchUpdateFields({ ids: [id], field, value }));
      });

      dispatch(discardEdit(id));
    };

    const handleCancel = () => {
      dispatch(discardEdit(id));
    };

    const isEdited = !!editedRows[id];
    return isEdited
      ? [
          <GridActionsCellItem icon={<SaveIcon />} label="Save" onClick={handleSave} />,
          <GridActionsCellItem icon={<CancelIcon />} label="Cancel" onClick={handleCancel} />
        ]
      : [
          <GridActionsCellItem icon={<EditIcon />} label="Edit" onClick={() => dispatch(startEditingRow(id))} />
        ];
  }, [editedRows, dispatch]);

  // Add our tool buttons to the end of the columns
  useEffect(() => {
    async function GetSetData() {
      //if (columnSetupDone) return;
      var tmpcols = await getColumnModel()
        tmpcols = tmpcols.filter(item => item.field !== 'actions')
        tmpcols.push(
          {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: getActionButtons
          }
        )
        setStateColumns(tmpcols)

    }
    GetSetData();
  },[pageSize, sortModel, rowModesModel, getActionButtons])

  // Only Switch Row Height if it has changed
  useEffect(() => {
    const map = {
      compact: 24,
      standard: 28,
      comfortable: 32
    };

    const newHeight = map[density] ?? 28;
    if (rowHeight !== newHeight) {
      setRowHeight(newHeight);
    }
  }, [density]);

  // DataGrid Context Menus
  const handleContextMenu = (event) => {
    event.preventDefault();
    const irow = Number(event.currentTarget.getAttribute("data-id"))
    dispatch(selectRow(irow))
    setSelectedRow(irow);
    const srchrow = records.find(item => item.id === irow)
    if(typeof srchrow !== 'undefined' && srchrow !== null) {
      console.log(`row set to`, srchrow)
      dispatch(setRowData(srchrow))
      dispatch(setCompanyName(srchrow['CompanyName']))
      dispatch(setCompanyNumber(srchrow['Company Number']))
      dispatch(setMainContact(srchrow['FullName']))
    }
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : null
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const editRow = () => {
    console.log(`editROW: selrow set to: `, selrow);
    dispatch(setSelectedTab(3))
    dispatch(setEditRecord(true))
    setContextMenu(null);
  };

  const viewRow = () => {
    console.log(`viewROW: selrow set to: `, selrow);
    dispatch(setSelectedTab(2))
    dispatch(setViewRecord(true))
    setContextMenu(null);
  };

  const fncviewNotes = () => {
    dispatch(setViewNotes(true))
    setContextMenu(null);
  };

  const fncviewPhoneCalls = () => {
    dispatch(setViewPhoneCalls(true))
    setContextMenu(null);
  };

  const fncviewCustomerEmails = () => {
    dispatch(setViewCustomerEmails(true))
    setContextMenu(null);
  };

  const fncviewCompanyDetails = () => {
    dispatch(fetchCompanyDetails());
    dispatch(fetchCompanyFilings());
    dispatch(fetchCompanyOfficers());
    dispatch(setViewChouseDetails(true));
    setContextMenu(null);
  }

  const fncsendEmail = () => {
    dispatch(startCompose(true));
    dispatch(setSelectedTab(4))
    setContextMenu(null);

  }

  const fncGenAgreement = () => {
    dispatch(fetchCompanyDetails());
    setShowAgreement(true);
    setContextMenu(null);
  }


  // End Context Menus

  const handleCellEditCommit = (params) => {
    /*dispatch(updateRecord({
      id: params.id,
      changes: {
        [params.field]: params.value
      }
    })); */
    // You can trigger your DB update here if you like
    // e.g., call updateRecordInDB(params.id, params.field, params.value)
  };

  const handleSortModelChange = (model) => {
    if (model.length > 0) {
      dispatch(setOrderBy(model[0]));
    } else {
      dispatch(setOrderBy(null));
    }
  };

  const handleFilterModelChange = (model) => {
    dispatch(setFilterBy(model));
    dispatch(fetchRecords());
  };

  const handlePageSizeChange = (newPageSize) => {
    dispatch(setPageSize(newPageSize));
    dispatch(fetchRecords());
  };

  const nextPage = () => {
    if (forwardCursor) {
      dispatch(goForward(forwardCursor));
      dispatch(fetchRecords());
    }
  };

  const prevPage = () => {
    if (backwardCursor) {
      dispatch(goBackward(backwardCursor));
      dispatch(fetchRecords());
    }
  };

  async function getColumnModel(modelin = null){
    var mod = modelin

    if(modelin === null)
      mod = model

    if(markColumnsInitialized && typeof columns !== 'undefined'  && columns.length > 0) {
      //setTable('ttp_leads')
      setVisibilityModel(ttpVisibilityModel)
      setSizeOptions(ttpsizeOptions)
      setGridWidth('100%')
      setFullCols(ttpcolumns)
      try {
       const tmpcols = JSON.parse(columns)

       const cols = ttpcolumns.map(item => ({
        field: item.field,
        headerName: item.headerName,
        type: item.type,
        editable: item.editable,
        hideable: item.hideable,
        visible: item.visible,
        valueGetter: item.valueGetter,
        valueFormatter: item.valueFormatter,
        renderCell: item.renderCell,
        minWidth: item.minWidth??100
      }));
       return cols
      }catch(err) {
        dispatch(markColumnsInitialized(false))
      }
    }


    const cols = ttpcolumns.map(item => ({
      field: item.field,
      headerName: item.headerName,
      type: item.type,
      editable: item.editable,
      hideable: item.hideable,
      visible: item.visible,
      valueGetter: item.valueGetter,
      valueFormatter: item.valueFormatter,
      renderCell: item.renderCell,
      minWidth: item.minWidth??100
    }));
    switch (model) {
      case 'ttpcolumns':
        //setTable('ttp_leads')
        setVisibilityModel(ttpVisibilityModel)
        setSizeOptions(ttpsizeOptions)
        setGridWidth('100%')
        setFullCols(ttpcolumns)
        dispatch(setColumns(JSON.stringify(cols)))
        dispatch(markColumnsInitialized(true));
        return cols;
      default:
        //setTable('ttp_leads')
        setVisibilityModel(ttpVisibilityModel)
        setSizeOptions(ttpsizeOptions)
        setGridWidth('100%')
        setFullCols(ttpcolumns)
        //dispatch(selectModel(ttpcolumns))
        dispatch(setColumns(JSON.stringify(cols)))
        dispatch(markColumnsInitialized(true));
        return cols;
    }
  }

  const longPressEvent = useLongPress(onLongPress, handleContextMenu, defaultOptions);

  const debounceFilterChange = useCallback(
    debounce((model) => {
      dispatch(setFilterBy(model));
      dispatch(fetchRecords());
    }, 500), // 500ms debounce
    []
  );

  const updateSearchField = (e) => {
    setSearchValue(e.target.value)
  }

  const selectSearchField = (e) => {
    setSearchField(e.target.value)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'columns', height: '100vh', width: '100%'}}>
      <GenerateAgreement open={showAgreement} onClose={() => setShowAgreement(false)} />
      <CompanyHouseDetails />
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <Box sc={{height: '80vh', width: '100%'}}>
      <PopupNotes open={viewNotes} id={rowdata.uid} data={rowdata} uid={rowdata.id}  />
      <PopupPhoneCalls open={viewPhoneCalls} id={rowdata.uid} data={rowdata} uid={rowdata.id}  />
      <PopupCustomerEmails open={viewCustomerEmails} id={rowdata.uid} data={rowdata} uid={rowdata.id}  />
      {showalert && <Alert variant="outlined" severity="success" onClose={onCloseAlert} >{alertMsg}</Alert> }
        <div style={{verticalAlign: 'center', display: 'inline-block', height: '50px', lineHeight: '50px', margin: 0, padding: 0 }} >Search
          {/* <FormControl variant="standard" sx={{ m: 1, minWidth: 120, "& .MuiInputBase-root-MuiInput-root-MuiSelect-root::before": { border: '4px solid red'} }} > */}
          <Select
            value={searchfield}
            onChange={selectSearchField}
            variant="standard"
            size="small"

            sx={{ border: 'none', marginLeft: '10px', marginRight: '10px',  "& .MuiSelect-root{ }::before":{borderBottom: 0} }}

          >
            <MenuItem value="ALL">All Fields</MenuItem>
            <MenuItem value="CompanyName">Company Name</MenuItem>
            <MenuItem value="FullName">Name</MenuItem>
            <MenuItem value="Email">Email</MenuItem>
            <MenuItem value="Phone1">Phone 1</MenuItem>
            <MenuItem value="Phone2">Phone 2</MenuItem>
            <MenuItem value="Mobile">Mobile</MenuItem>
            <MenuItem value="Address">Address Line 1</MenuItem>
            <MenuItem value="Postcode">Postcode</MenuItem>
          </Select>
          {/* </FormControl> */}
          for the Value
          <TextField sx={{verticalAlign: 'middle', marginLeft: '10px', maxWidth: '40ch', width: `${searchvalue.length+2}ch`}} value={searchvalue} onChange={updateSearchField} type="search" variant="standard" />
          <Button variant='outlined' size='small' sx={{marginLeft: '15px' }}>Search</Button>
        </div><br/>
        {(records??[]).length > 0 && (statecolumns??[]).length > 0 &&
        <Box sx={{ height: '100%'}} >
        <DataGrid
            id="mainGrid"

            rows={records}
            columns={statecolumns??[]}
            loading={loading}
            rowCount={totalCount}
            getRowId={(row) => row.id}
            paginationMode="server"
            pageSizeOptions={[25, 50, 100]}
            pageSize={pageSize??25}
            processRowUpdate={processRowUpdate}
            onCellEditStart={(params, event) => {
              if (!permission_edit) {
                event.defaultMuiPrevented = true;
              }
            }}

            onRowEditStart={(params, event) => {
              if (!permission_edit) {
                event.defaultMuiPrevented = true;
              }
            }}
            experimentalFeatures={{ newEditingApi: true }}
            componentsProps={{
                row: {
                onContextMenu: handleContextMenu,
                style: { cursor: "context-menu" },
                ...longPressEvent
                }
            }}

            onPageSizeChange={(newSize) => {
                dispatch(setPageSize(newSize))
                dispatch(fetchRecords());
              }
            }

            paginationModel={{
                page: page??0,
                pageSize: pageSize??25
            }}

            onPaginationModelChange={(model, details) => {
              if(model.pageSize !== pageSize) {
                  dispatch(setPageSize(model.pageSize))
                  dispatch(fetchRecords());
              }else {
                if (totalCount > parseInt(model.page*pageSize) && model.page > page) {
                  dispatch(goForward(forwardCursor));
                  dispatch(setPage(model.page))
                  dispatch(fetchRecords());
                } else if (model.page >= 0 && model.page < page) {
                  dispatch(goBackward(backwardCursor));
                  dispatch(setPage(model.page))
                  dispatch(fetchRecords());
                }
              }
                // Reset to "fake" page 0 after each change
            }}
            millio
            sortingMode="server"
            onSortModelChange={(model) => {
                console.log(`sortModelChange `, model)
                dispatch(setOrderBy(model.length ? model[0] : null));
                dispatch(fetchRecords());
            }}
            filterMode="server"
            onFilterModelChange={(newModel) => { debounceFilterChange(newModel) }}

            onCellEditCommit={(params) => {
                /*dispatch(updateRecord({
                id: params.id,
                changes: { [params.field]: params.value }
                }));*/
            }}
            disableRowSelectionOnClick

            columnVisibilityModel={visibilityModel}
            autosizeOptions={sizeoptions}
            autosizeOnMount={true}
            checkboxSelection={true}
            columnBufferPx={100}
            density={density}
            onDensityChange={(newDensity) => setDensity(newDensity) }
            rowHeight={rowHeight??50}
            sx={{
              maxHeight: '80vh',
              width: gridwidth,
            '& .MuiDataGrid-cell': {
                color: 'rgba(0,0,0,.85)',
                fontSize: '6pt',
            },
            '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
                borderRight: '1px solid #e0e0e0',
                fontSize: '8pt',
            },
            '& .MuiToolbar-root MuiToolbar-gutters .MuiToolbar-regular MuiTablePagination-toolbar': {
              width: `${width?width + 'px':'100%'}`
            }
            /*
<div class="MuiToolbar-root MuiToolbar-gutters MuiToolbar-regular MuiTablePagination-toolbar css-1gak8h1-MuiToolbar-root-MuiTablePagination-toolbar"><div class="MuiTablePagination-spacer css-1wtxofq-MuiTablePagination-spacer"></div><p id=":raid:" class="MuiTablePagination-selectLabel css-s09cke-MuiTablePagination-selectLabel">Rows per page:</p><div class="MuiInputBase-root MuiInputBase-colorPrimary MuiTablePagination-select MuiSelect-root MuiTablePagination-input css-oegngy-MuiInputBase-root-MuiTablePagination-select"><div tabindex="0" role="combobox" aria-expanded="false" aria-haspopup="listbox" aria-labelledby=":raid: :raic:" id=":raic:" class="MuiSelect-select MuiTablePagination-select MuiSelect-standard MuiInputBase-input css-mmygx2-MuiSelect-select-MuiInputBase-input">25</div><input aria-invalid="false" aria-hidden="true" tabindex="-1" class="MuiSelect-nativeInput css-j0riat-MuiSelect-nativeInput" value="25"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiTablePagination-selectIcon MuiSelect-iconStandard css-1gpuzre-MuiSvgIcon-root-MuiSelect-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowDropDownIcon"><path d="M7 10l5 5 5-5z"></path></svg></div><p class="MuiTablePagination-displayedRows css-11cfq65-MuiTablePagination-displayedRows">1–25 of 117</p><div class="MuiTablePagination-actions"><button class="MuiButtonBase-root Mui-disabled MuiIconButton-root Mui-disabled MuiIconButton-colorInherit MuiIconButton-sizeMedium css-h7cjts-MuiButtonBase-root-MuiIconButton-root" tabindex="-1" type="button" disabled="" aria-label="Go to previous page" title="Go to previous page"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="KeyboardArrowLeftIcon"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"></path></svg></button><button class="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit MuiIconButton-sizeMedium css-h7cjts-MuiButtonBase-root-MuiIconButton-root" tabindex="0" type="button" aria-label="Go to next page" title="Go to next page"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="KeyboardArrowRightIcon"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path></svg></button></div></div>
            */
            }}
            slots={{
                toolbar: EditToolbar,
            }}

            slotProps={{
                toolbar: {  setRows, setRowModesModel },
                row: {
                    onContextMenu: handleContextMenu,
                    style: { cursor: "context-menu", flex:1, flexDirection: 'row' }
                }
            }}

            getRowClassName={(params) => {
              const isEditing = editedRows[params?.id];
              const isFading = params.row._fadeIn;

              return [
                isEditing ? 'row-editing' : '',
                isFading ? 'fade-in-row' : ''
              ].join(' ').trim();
            }}
        />
        </Box>
          }
        <Menu
            open={contextMenu !== null}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={
            contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined
            }
            componentsProps={{
            root: {
                onContextMenu: (e) => {
                e.preventDefault();
                handleClose();
                }
            }
            }}
        >
            <MenuItem onClick={editRow} disabled={!permission_edit??true} >Edit Lead</MenuItem>
            <MenuItem onClick={viewRow}>View Lead</MenuItem>
            <MenuItem onClick={fncviewNotes}>View Notes</MenuItem>
            <MenuItem onClick={fncviewPhoneCalls}>View Phone Calls</MenuItem>
            <MenuItem onClick={fncviewCustomerEmails}>View Email History</MenuItem>
            <MenuItem onClick={fncviewCompanyDetails}>CHouse Details</MenuItem>
            <MenuItem onClick={fncsendEmail}>Send Email</MenuItem>
            <MenuItem onClick={fncGenAgreement}>Generate Contract</MenuItem>
        </Menu>


        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
              dispatch(hidePopup())
                // Optional: restore focus somewhere intentional
              setTimeout(() => {
                document.querySelector('#mainGrid')?.focus();
              }, 50);
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            disableRestoreFocus
            disableAutoFocus
            disableEnforceFocus
        >
            <Typography sx={{ p: 2, maxWidth: 300 }}>
                {popupValue || 'No content'}
            </Typography>
        </Popover>
    </Box>
    <Snackbar
        open={!!snackbar}
        autoHideDuration={3000}
        onClose={() => setSnackbar(null)}
        message={snackbar?.message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />

    </Box>
  );
};

export default DataGridWrapper;